export const getLowerHunterValleyData = () => ({
  name: "Lower Hunter Valley",
  country: "Australie",
  region: "Hunter Valley",
  description: "Lower Hunter Valley est le cœur historique de la Hunter Valley, réputé pour ses Sémillon uniques et ses Shiraz élégants. Son climat subtropical et ses sols volcaniques créent des conditions idéales pour des vins de caractère unique.",
  type: "subregion",
  mapAreas: [
    { region: "Lower Hunter Valley", x: 55, y: 65, color: "#6d2c7a", size: 5 }
  ],
  statistics: {
    totalArea: "5,000 ha",
    production: "0.4 million hectolitres",
    altitude: "100-300m",
    appellations: "Lower Hunter Valley GI",
    exportPercentage: "30%"
  },
  characteristics: {
    climate: "Climat subtropical avec étés chauds et humides, hivers doux, influence océanique",
    soil: "Sols volcaniques, argileux, excellente rétention d'eau",
    viticulture: "Viticulture traditionnelle, vieilles vignes, vendanges manuelles"
  },
  wineStyles: {
    red: "Shiraz élégants et épicés, avec des tanins soyeux et une complexité aromatique",
    white: "Sémillon uniques, vieillissement exceptionnel, notes de miel et de cire",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "Lower Hunter Valley est le berceau de la viticulture australienne, fondée par James Busby en 1825. La sous-région a développé des styles de vins uniques, notamment le Sémillon qui vieillit exceptionnellement bien.",
  foodPairing: "Cuisine australienne : fruits de mer, poissons, viandes blanches, fromages affinés, cuisine fusion.",
  grapeVarieties: {
    white: ["Sémillon", "Chardonnay", "Verdejo"],
    red: ["Shiraz", "Cabernet Sauvignon", "Merlot"]
  },
  keyProducers: ["Tyrrell's", "McWilliam's", "Brokenwood"],
  notableWines: {
    "semillon": "Sémillon uniques, vieillissement exceptionnel",
    "shiraz": "Shiraz élégants et épicés",
    "chardonnay": "Chardonnay aromatiques et complexes"
  }
}); 